if (!customElements.get('mobile-sticky-bar')) {
  customElements.define(
    'mobile-sticky-bar',

    class MobileStickyBar extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        document.body.classList.add('mobile-sticky-bar-enabled');
        this.pin();
        this.calculateHeight();
      }

      // Панель закреплена внизу и при прокрутке не прячется.
      //
      // Исходный скрипт темы прятал её движением пальца вверх: класс
      // down даёт transform: translateY(100%). Получалось наоборот —
      // навигация уезжала ровно тогда, когда к ней тянутся, и
      // возвращалась при прокрутке вниз, то есть при чтении.
      //
      // Классы оставляем на месте: от body.mobile-sticky-bar-down
      // зависят отступы кнопки «наверх» (snippets/back-to-top.liquid)
      // и полосы «в корзину» (assets/section-sticky-atc-bar.css). Оба
      // правила рассчитаны на спрятанную панель, поэтому при видимой
      // должны молчать — за них отвечают значения по умолчанию,
      // которые уже учитывают --mobile-sticky-bar-height.
      pin() {
        this.classList.add('up');
        this.classList.remove('down');
        document.body.classList.add('mobile-sticky-bar-up');
        document.body.classList.remove('mobile-sticky-bar-down');
      }

      calculateHeight() {
        requestAnimationFrame(() => {
          document.documentElement.style.setProperty('--mobile-sticky-bar-height', `${this.offsetHeight}px`);
        });
      }
    }
  );
}
